import { ApiError } from './api-client';

/** Mensagem amigável para exibir em toasts/formulários. */
export function errorMessage(
  error: unknown,
  fallback = 'Não foi possível concluir a operação',
): string {
  if (ApiError.is(error)) {
    if (error.fields?.length) {
      return error.fields.map((f) => f.messages.join(', ')).join('; ');
    }
    return error.message || fallback;
  }
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
